import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.slice.js";

/**
 * Checks window location to determine if app is running in an allowlist of hosts.
 */
var isValidHostname = function isValidHostname(hostname) {
  var hostnames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validHostnames = ['nerdwallet.com', 'nerdwallet.biz', 'nerdwallet.io', 'nerdwallet.style', 'localhost'].concat(_toConsumableArray(hostnames));
  return !!validHostnames.find(function (validHostname) {
    return validHostname === hostname.slice(-1 * validHostname.length);
  });
};

export default isValidHostname;